import { createFileRoute, Outlet, redirect, useNavigate, useParams, useRouter } from "@tanstack/react-router";
import type { WhoAmI } from "@nodus/api";
import { lastScope, rememberScope } from "../../app/scope";
import { Marketplace } from "../../features/marketplace/marketplace";
import { reservedPath } from "../../features/marketplace/navigation";

export const Route = createFileRoute("/_authed/reserved-compute")({
  loader: async ({ context }) => {
    const orgs = await context.queryClient.fetchQuery({ queryKey: ["user", "orgs", context.session.user.id], queryFn: context.api.organizations });
    if (!orgs.length) throw redirect({ to: "/onboarding", search: { destination: "reserved-compute" } });
    const last = lastScope(context.session.user.id).org;
    const org = orgs.find((o) => o.metadata.name === last) ?? orgs[0]!;
    const me = await context.client.get<WhoAmI>("/auth/whoami", { org: org.metadata.name });
    rememberScope(context.session.user.id, org.metadata.name);
    return { org, orgs, me };
  },
  component: Page,
});

function Page() {
  const data = Route.useLoaderData();
  const { client, auth, session } = Route.useRouteContext();
  const { marketView } = useParams({ strict: false }) as { marketView?: string };
  const navigate = useNavigate();
  const router = useRouter();
  return <><Marketplace key={data.org.metadata.name} {...data} client={client} email={session.user.email}
    view={marketView === "contracts" ? "Contracts" : marketView === "requests" || marketView === "request" ? "Requests" : "Capacity"}
    requestOpen={marketView === "request"}
    onRequest={() => void navigate({ href: "/reserved-compute/request" })}
    onViewChange={(view) => void navigate({ href: reservedPath(view) })}
    onOrgChange={(org) => { rememberScope(session.user.id, org); void router.invalidate(); }}
    signOut={async () => { await auth.signOut(); window.location.assign("/sign-in"); }}
  /><Outlet /></>;
}
